<template>
    <div class="generic-modal-container" v-if="!hidden" @click="bgClicked" :class="{
        opened: !hidden,
        'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50': !hidden,
        opaque: isOpaque
    }">
        <div class="generic-modal">
            <div class="overflow-hidden" style="height: 75vh">
                <div class="relative h-full w-full pr-2 overflow-y-scroll">
                    <div class="py-2">
                        <div
                            class="bg-green-100 text-green-700 mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10 float-left">
                            <i class="fas fa-warehouse-alt"></i>
                        </div>
                        <heading size="medium" class="mt-2 ml-2 float-left">
                            Create a new Package
                        </heading>
                    </div>
                    <crud-errors class="mt-12" :errors="errors"></crud-errors>
                    <div class="grid gap-6 grid-cols-12 py-6 w-full">
                        <div class="col-span-6 grid grid-cols-12 py-2">
                            <div v-if="new_item.project_associate == false" class="col-span-12 mb-4">
                                <ui-input label="Project Name"
                                          v-model="new_item.project_name"></ui-input>
                                <span class="mt-1 mb-4 text-right block">
                <a href="#" class="text-brand hover:text-brand-dark" @click.prevent="new_item.project_associate = true">Click to associate with existing project</a>
              </span>

                            </div>
                            <div v-if="new_item.project_associate == true" class="col-span-12 mb-4">
                                <ui-select-searchable
                                    label="Choose a Project"
                                    v-model="new_item.projects_dd"
                                    :search="(e) => getProjects(e,(a) => {})"
                                    class="col-span-12"
                                    :options="projects"
                                    no-search="Associate With A Project..."
                                ></ui-select-searchable>
                                <span class="mt-1 mb-4 text-right block">
                <a class="text-brand hover:text-brand-dark" href="#"
                   @click.prevent="new_item.project_associate = false">Click to choose a new project name</a>
              </span>
                            </div>
                            <ui-input class="mb-8" label="Package Name / Reference"
                                      v-model="new_item.name"></ui-input>
                            <ui-textarea class="mb-8" label="Address"
                                         v-model="new_item.address"></ui-textarea>
                            <ui-input class="mb-8" label="Postcode"
                                      v-model="new_item.postcode"></ui-input>
                            <div class="col-span-12">
                                <label class="block text-sm font-medium text-gray-700 mb-1">Choose A Client</label>
                                <div class="mb-6">
                                    <v-select :key="clientRefreshDropdown"
                                              v-model="new_item.client_dd"
                                              :on-search="getPeopleAndCompanies"
                                              :options="peopleAndCompanies"
                                              placeholder="Associate With A Client...">
                                                                <span
                                                                    slot="no-options">Start typing to find clients.</span>
                                    </v-select>
                                    <div class="mt-2 block text-right">
                                        <a class="text-brand hover:text-brand-light text-sm"
                                           href="#"
                                           @click.prevent="createCompany()"><i
                                            class="fas fa-plus"></i> New Company</a>
                                        <a class="text-brand hover:text-brand-light text-sm ml-2"
                                           href="#"
                                           @click.prevent="createContact()"><i
                                            class="fas fa-plus"></i> New Person</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-6 grid grid-cols-12 py-2">
                            <ui-select-searchable
                                class="col-span-12"
                                label="Category"
                                v-model="new_item.category_dd"
                                :options="categories"
                            ></ui-select-searchable>
                            <ui-select-searchable
                                class="col-span-12"
                                label="Expected Work Categories"
                                v-model="new_item.work_categories_dd"
                                :options="work_categories"
                            ></ui-select-searchable>
                            <ui-select-searchable
                                class="col-span-12"
                                label="Work Types"
                                v-model="new_item.work_types_dd"
                                :options="work_types"
                            ></ui-select-searchable>
                            <ui-select-searchable
                                class="col-span-12"
                                label="Enquiry Type"
                                v-model="new_item.enquiry_types_dd"
                                :options="enquiry_types"
                            ></ui-select-searchable>
                            <ui-date-picker class="col-span-12" label="Enquiry Date" name="enquiry_date"
                                            placeholder="Enquiry Date..."
                                            v-model="new_item.enquiry_date"></ui-date-picker>
                            <ui-date-picker class="col-span-12" label="Return Date" name="return_date"
                                            placeholder="Return Date..."
                                            v-model="new_item.return_date"></ui-date-picker>

                        </div>
                    </div>
                    <div class='w-full bg-white'>
                        <div
                            class="px-4 bg-white py-3 flex flex-col md:px-6 md:flex-row-reverse rounded-b-lg">
                            <ui-button class="sm:ml-2" colour="green" @click.prevent="addItem()">
                                <i class="fas fa-plus-circle mr-1"></i> Create Package
                            </ui-button>
                            <ui-button @click.prevent="closeModal()" colour="gray">
                                <i class="fas fa-times-circle mr-1"></i> Cancel
                            </ui-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import Heading from "../ui/Heading.vue";
import UiInput from "../ui/UiInput.vue";
import UiTextarea from "../ui/UiTextarea.vue";
import UiDatePicker from "../ui/UiDatePicker.vue";
import moment from "moment";

export default {
    components: {UiDatePicker, UiTextarea, UiInput, Heading, flatPickr, vSelect},
    props: {
        afterCreationUrl: '',
        isOpaque: true,
    },
    computed: {
        categories: function () {
            return this.getOptionsForDropdownByKey('categories');
        },
        work_categories: function () {
            return this.getOptionsForDropdownByKey('work_categories');
        },
        work_types: function () {
            return this.getOptionsForDropdownByKey('work_types');
        },
        enquiry_types: function () {
            return this.getOptionsForDropdownByKey('enquiry_types');
        },
    },
    data() {
        return {
            name: 'package',
            new_item: {
                project_associate: false,
                enquiry_date: moment().format('YYYY-MM-DD'),
                return_date: null,
            },
            clientRefreshDropdown: 1,
            peopleAndCompanies: [],
            projects: [],
            options: null,
            errors: null,
            hidden: true,
        }
    },
    methods: {
        createContact() {
            let that = this;
            window.eventBus.$emit('create-new-contact');
        },
        createCompany() {
            let that = this;
            window.eventBus.$emit('create-new-company');
        },
        getOptionsForDropdownByKey(key) {
            var returnable = [];
            if (_.isObject(this.options)) {
                _.forEach(this.options[key], function (item, id) {
                    returnable.push({
                        label: item,
                        value: id
                    });
                });
            }
            return returnable;
        },
        getOptions: function () {
            var that = this;
            axios.get(appUrls.packages.options)
                .then(response => {
                    that.options = response.data.data;
                });
        },
        getPeopleAndCompanies: _.debounce(function (search, loading) {
            var that = this;

            if (!search) {
                return;
            }

            loading(true);
            that.peopleAndCompanies = [];
            axios.get(appUrls.suppliers.options, {params: {'query': search}})
                .then(response => {
                    _.forEach(response.data.data, function (personOrCompany) {
                        that.peopleAndCompanies.push({
                            label: personOrCompany.name,
                            value: personOrCompany.type + '_' + personOrCompany.id
                        });
                    });
                    loading(false);
                });
        }, 500),
        getProjects: _.debounce(function (search, loading) {
            if (!search) {
                return;
            }

            var that = this;
            loading(true);
            that.projects = [];
            axios.get(appUrls.projects.index, {params: {'query': search}})
                .then(response => {
                    _.forEach(response.data.data, function (project) {
                        that.projects.push({
                            label: project.id + ': ' + project.title,
                            value: project.id
                        });
                    });
                    loading(false);
                });
        }, 500),
        openModal() {
            this.new_item = {
                project_associate: false,
                enquiry_date: moment().format('YYYY-MM-DD'),
                return_date: null,
            }
            this.resetErrors();
            window.eventBus.$emit('modal-open-create-package-modal');
            this.hidden = false
        },
        closeModal() {
            window.eventBus.$emit('modal-close-create-package-modal');
            this.new_item = {
                project_associate: false,
                enquiry_date: moment().format('YYYY-MM-DD'),
                return_date: null,
            }
            this.resetErrors();
            this.hidden = true;
        },
        bgClicked(e) {
            if (e.target.classList.contains('generic-modal-container')) {
//                this.closeModal();
            }
        },
        resetErrors() {
            window.eventBus.$emit('crud-errors-dismissed');
        },
        addItem() {
            var that = this;
            var data = $.extend({}, this.new_item);
            var keysToTransform = [
                {'keyName': 'projects_dd', 'keyTo': 'project_id'},
                {'keyName': 'client_dd', 'keyTo': 'client'},
                {'keyName': 'category_dd', 'keyTo': 'package_category_id'},
                {'keyName': 'work_categories_dd', 'keyTo': 'expected_work_categories'},
                {'keyName': 'work_types_dd', 'keyTo': 'package_work_types'},
                {'keyName': 'enquiry_types_dd', 'keyTo': 'enquiry_type_id'},
            ];

            _.forEach(keysToTransform, function (keyDetails) {

                if (_.isObject(data[keyDetails.keyName])) {
                    data[keyDetails.keyTo] = data[keyDetails.keyName].value;
                }

                delete data[keyDetails.keyName];
            });

            axios.request({
                method: 'post',
                url: route('api.v1.packages.store'),
                data: data,
                config: {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            }).then(response => {
                window.eventBus.$emit('package-created', response.data.data);

                that.closeModal();
                window.location.href = response.data.data._links.frontend.view;
            }).catch(function (error) {
                if (error.response.status === 422) {
                    that.errors = error.response.data.errors;
                }
            });
        },
        refreshClientDropdown() {
            this.clientRefreshDropdown = this.clientRefreshDropdown + 1;
        },
        backToNav: function () {
            window.eventBus.$emit('crud-back-to-nav-' + this.name);
        }
    },
    mounted() {
        if (window.appUrls) {
            var that = this;
            this.getOptions();

            window.eventBus.$on('create-new-package', function () {
                that.openModal();
            });

            window.eventBus.$on('contact-created', function (contact) {
                that.new_item.client_dd = {
                    label: contact.name,
                    value: contact.type + '_' + contact.id
                };
                that.refreshClientDropdown();
                that.getPeopleAndCompanies();
            });

            window.eventBus.$on('company-created', function (company) {
                that.new_item.client_dd = {
                    label: company.name,
                    value: company.type + '_' + company.id
                };
                that.refreshClientDropdown();
                that.getPeopleAndCompanies();
            });

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../sass/setup';

.generic-modal-container {
    display: none;

    &.opened {
        position: absolute;
        min-height: 100vh;
        width: 100vw;
        z-index: +50;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        padding: 2em;
        @include desktop() {
            &.opaque {
                background-color: rgba(255, 255, 255, 1);
            }
        }
    }
}

.generic-modal {
    padding: 1em;
    @include grid-column(12);
    @include clearfix();
    @include desktop() {
        background-color: #fff;
        border-radius: 0.5em;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        @include grid-column(8);
        max-width: 1024px;
        padding: 2em;
    }

    div.actions {
        text-align: left;
        margin-top: 30px;

        a, input[type="submit"] {
            padding: 0.7em 0.7em 0.8em;
            text-decoration: none;
            color: #fff;
            border-radius: $standardBorderRadius;
        }

        input[type="submit"] {
            background-color: $green;
        }

        a {
            background-color: #999;
        }

        a.success {
            background-color: $green;
        }

        @include desktop() {
            float: right;
            text-align: right;
        }
    }
}

li.contact {
    margin: 1em 0;
}

.meta, .name {
    @include clearfix();

    small {
        float: right;
        text-align: right;
    }
}

.name small {
    opacity: 0.5;
}

.meta {
    font-size: 0.8em;
    opacity: 0.5;

    small {
        font-size: 1em;
    }
}

.person-meta, .company-meta {
    @include grid-column(6);
    @include mobile() {
        @include grid-column(12);
    }
}

.position {
    text-align: center;
    font-weight: 300;
    font-size: 2em;
    margin: 1em 0 2em;
}
</style>
